import React, { useMemo } from 'react';
import { APIS, SPORTS } from '../../../utils/constants';
import ManageFieldsDialog from '../manageFieldsDialog';

const ManageLeagueDialogWrapper = ({ open, onConfirm, onClose, league }) => {
  const data = useMemo(
    () =>
      league
        ? { ...league, customName: league.customName ?? '' }
        : {
            name: '',
            customName: '',
            source: APIS.INTERNAL,
            sportId: SPORTS.CRICKET,
          },
    [league]
  );

  const fields = useMemo(
    () => [
      { name: 'name', label: 'Name', type: 'text' },
      { name: 'customName', label: 'Custom name', type: 'text', required: false },
    ],
    []
  );

  return (
    <ManageFieldsDialog
      open={open}
      onConfirm={onConfirm}
      onClose={onClose}
      data={data}
      fields={fields}
      title="New league"
    />
  );
};

export default ManageLeagueDialogWrapper;
